import { LinkBreak2Icon } from '@radix-ui/react-icons';
import { ImgHTMLAttributes, useEffect, useState, type JSX } from 'react';

import { cn } from '../../utils/cn';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallback?: JSX.Element;
}

export function Image({ alt = 'imagen', className, fallback, onError, src, ...props }: ImageProps) {
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    setIsBroken(false);
  }, [src]);

  if (isBroken) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (fallback) return <>{fallback}</>;

    return (
      <div className={cn('flex items-center justify-center text-muted-foreground', className)}>
        <LinkBreak2Icon />
      </div>
    );
  }

  return (
    <img alt={alt} className={className} src={src} onError={() => setIsBroken(true)} {...props} />
  );
}
